export function convertDecimalToPercent(value: number): number {
  return Math.round(value * 10000) / 100;
}

export function convertPercentToDecimal(value: number): number {
  return Math.round(value * 100) / 10000;
}
